export const getXYForTwoCircles = (radius1, radius2, angle, x0 = 0, y0 = 0) => {
  const x = x0 + (radius1 + radius2) * Math.cos((angle * Math.PI) / 90);
  const y = y0 + (radius1 + radius2) * Math.sin((angle * Math.PI) / 90);
  return { x, y };
};

// export const getXForThreeCircles = ({radius1, radius2, radius3, k = 1}) => {
//   return k * (radius1 * (radius1 + radius3) + radius2 * (radius1 - radius3)) / (radius1 + radius2)
// }
//
// export const getYForThreeCircles = ({radius1, radius2, radius3, k = 1}) => {
//   return k * 2 * Math.sqrt(radius1 * radius2 * radius3 * (radius1 + radius2 + radius3)) / (radius1 + radius2)
//}

const getD = (x1, y1, x2, y2) => {
  return Math.sqrt(Math.pow(x1 - x2, 2) + Math.pow(y1 - y2, 2));
};

const getA = (r1, r2, d) => {
  return (Math.pow(r1, 2) - Math.pow(r2, 2) + Math.pow(d, 2)) / (2 * d);
};

const getH = (r, a) => {
  return Math.sqrt(Math.pow(r, 2) - Math.pow(a, 2));
};

export const getXYForThreeCircles = (x1, x2, y1, y2, r1, r2, k = 1) => {
  const d = getD(x1, y1, x2, y2);
  const a = getA(r1, r2, d);
  const h = getH(r1, a);
  const x3 = x1 + (a * (x2 - x1)) / d;
  const y3 = y1 + (a * (y2 - y1)) / d;
  const x = x3 + (k * h * (y2 - y1)) / d;
  const y = y3 - (k * h * (x2 - x1)) / d;
  return { x, y };
};
